<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M16 4.666c6.25 0 11.334 5.083 11.334 11.333S22.25 27.333 16 27.333 4.667 22.249 4.667 15.999 9.75 4.666 16 4.666zm0-2c-7.363 0-13.333 5.97-13.333 13.333 0 7.364 5.97 13.334 13.333 13.334 7.364 0 13.334-5.97 13.334-13.334 0-7.363-5.97-13.333-13.334-13.333zm4.334 12.333H17v-3.333a1 1 0 00-2 0v3.333h-3.333a1 1 0 000 2H15v3.334a1 1 0 002 0v-3.334h3.334a1 1 0 000-2z"/></svg>
</template>

<script>
export default {
  name: 'symbolsCirclePlusOutline'
}
</script>
